import styled, { css } from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import { defaultTransition } from '../../../theme'
import { getRgbaValue } from '../../../utils/styling/getRgbaValue'

export const Container = styled(Box)`
  flex-direction: column;
  position: relative;
`

export const Section = styled(Box)<{ noBorder?: boolean; smaller?: boolean }>`
  flex-direction: column;
  margin: 64px 0 0;
  padding-bottom: 64px;
  border-bottom: ${({ noBorder }) => (noBorder ? 0 : 1)}px solid
    ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 0.15)};
  max-width: 737px;
  p {
    margin-bottom: 16px;
  }
  span.highlight {
    color: ${({ theme }) => theme.colors.brandPrimary};
  }
  h5 {
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.05em;
    font-weight: 600;
  }

  span.highlight-secondary {
    color: ${({ theme }) =>
      !theme.isDark ? theme.colors.brandSecondary : theme.colors.brandPrimary};
    display: flex;
    align-items: center;
    img {
      margin-left: 10px;
      margin-right: 0px;
    }
  }

  @media (max-width: 1200px) {
    max-width: 100%;
    padding-bottom: 0px;
    border-bottom: none;
  }
  ${({ smaller }) =>
    smaller &&
    css`
      @media screen and (min-width: 600px) {
        margin-top: 32px;
        padding-bottom: 32px;
      }
    `}
`

export const SectionTitle = styled.span`
  font-family: 'Space Grotesk';
  font-size: 24px;
  line-height: 30px;
  text-transform: uppercase;
  margin-bottom: 32px;
`

export const TableLabel = styled.span<{
  maxWidth?: number
  lighter?: boolean
  pseudoLink?: boolean
}>`
  font-family: ${({ lighter }) =>
    lighter ? 'Space Grotesk' : 'Space Grotesk'};
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '100%')};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span.nudge-left {
    padding-left: 4px;
  }
  ${({ pseudoLink }) =>
    pseudoLink &&
    css`
      cursor: pointer;
      font-weight: 600;
    `}
`

export const Table = styled(Box)`
  margin-right: 32px;
  span.notice {
    font-family: 'Space Grotesk';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    margin-top: 4px;
    opacity: 0.5;
  }
  strong {
    margin-bottom: 16px;
  }
  strong.label {
    margin-bottom: 0 !important;
  }
  @media screen and (max-width: 1000px) {
    .mobile-col {
      flex-direction: column;
    }
  }
  margin-bottom: 32px;
`

export const TableRow = styled(Box)<{ noBorder?: boolean }>`
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: ${({ noBorder }) => (noBorder ? 0 : 1)}px solid
    rgba(
      ${({ theme }) => (theme.isDark ? '255, 255, 255, 0.15' : '0, 0, 0, 0.15')}
    );
`
export const FAQContainer = styled(Box)<{
  isBlock?: boolean
  hasActiveTerm?: boolean
}>`
  flex-direction: column;
  @media screen and (min-width: 1200px) {
    ${({ isBlock, hasActiveTerm }) =>
      isBlock
        ? css``
        : css`
            max-width: 413px;
            position: fixed;
            top: 200px;
            /* height: 162px; */
            max-height: ${hasActiveTerm ? 3000 : 400}px;
          `}
  }
  padding: 24px;
  background: ${({ theme }) =>
    theme.isDark ? 'rgba(0, 0, 0, 0.3)' : theme.colors.checkoutBoxBackground};
  border: 1px solid ${({ theme }) => theme.colors.checkoutBoxBorder};
  backdrop-filter: blur(50px);
  border-radius: 18px;
  @media screen and (min-width: 1000px) and (max-width: 1400px) {
    left: calc((100vw - 64px - 430px));
  }
  @media screen and (min-width: 1400px) {
    left: calc((100vw - 1400px) / 2 + 990px);
  }
  h6 {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    margin-bottom: 16px;
  }
  img {
    margin-right: 10px;
  }
  img.chevron {
    filter: invert(${({ theme }) => (theme.isDark ? 0 : 100)}%);
  }
  img.chevron.rotate {
    transform: rotate(90deg) !important;
  }
  .list-item {
    margin-left: 20px;
    margin-bottom: 8px;
    cursor: pointer;
  }
  .list-item span {
    font-family: 'Space Grotesk';
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    opacity: 0.6;
  }

  span.copy {
    font-family: 'Space Grotesk';
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    opacity: 1;
    margin-left: 36px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 1000px) {
    position: relative;
    margin-top: 32px;
  }
  margin-bottom: 32px;
`

export const InputContainer = styled.div`
  position: relative;
  width: 140px;
  span {
    position: absolute;
    right: 10px;
    top: 19px;
    font-family: 'Space Grotesk';
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
    opacity: 0.3;
  }
  @media screen and (max-width: 1000px) {
    margin-top: 16px;
    width: 100%;
  }
`

export const ContentHolder = styled(Box)`
  max-width: calc(100% - 430px);
  @media screen and (max-width: 1200px) {
    max-width: 100%;
  }
`

export const MethodBox = styled(Box)`
  flex-direction: column;
  border: 1px solid
    ${({ theme }) =>
      theme?.isDark ? 'rgba(0, 0, 0, 0.1)' : theme.colors.checkoutBoxBorder};
  background: ${({ theme }) => theme.colors.checkoutBoxBackground};
  border-radius: 9px;
  padding: 24px;
  max-width: 737px;
  margin-bottom: 24px;
  span {
    font-size: 16px;
    line-height: 18px;
  }
  span.coming-soon {
    margin-left: auto;
    font-size: 12px;
    opacity: 0.8;
  }

  span.pad-bottom {
    padding-bottom: 16px;
  }

  @media screen and (max-width: 1000px) {
    .mobile-col {
      flex-direction: column;
    }
    .mobile-start {
      justify-content: flex-start;
      align-items: flex-start;
    }
    span.coming-soon {
      margin-top: 16px;
      /* text-align: left;
      margin-left: 0; */
    }
  }
`

export const UnstakedCTA = styled(Box)`
  align-items: center;
  justify-content: space-between;
  width: 737px;
  height: 82px;
  padding: 24px;
  background: rgba(61, 104, 255, 0.1);
  border-radius: 9px;
  margin: 20px 0 4px;
  img {
    margin-right: 21px;
  }

  ${({ theme }) =>
    theme.isDark &&
    css`
      background: rgba(61, 104, 255, 0.1);
      border: 1px solid #3d68ff;
    `};

  @media screen and (max-width: 1200px) {
    width: 100%;
  }
  @media screen and (max-width: 1000px) {
    flex-direction: column;

    img {
      margin: auto;
    }

    ${Box} {
      flex-direction: column;
      text-align: center;
      span {
        margin: 16px 0;
      }
    }
    img.chevron {
      margin-bottom: 5.5px;
      ${defaultTransition}
    }
    img.chevron.rotate {
      transform: rotate(90deg) !important;
    }
  }
`

export const Inner = styled(Box)`
  z-index: 100;
  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
`

export const TopTableContainer = styled(Box)`
  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
`

export const FullWidthSeperator = styled.div`
  width: 100vw;
  height: 1px;
  margin-left: -32px;
  margin-top: 16px;
  background: ${({ theme }) =>
    getRgbaValue(theme.semantics.zap.surface.primary, 0.15)};
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const NoticeBox = styled(MethodBox)`
  background: rgba(61, 104, 255, 0.1);
  img.ions-logo {
    margin-right: 16px;
    margin-bottom: 16px;
  }
  .quickswap-button {
    min-width: 220px;
  }
`

export const KYCContainer = styled(Box)<{ isApproved: boolean }>`
  padding: 24px;
  padding-left: 0;
  padding-bottom: 0;
  gap: 15px;
  width: 100%;
  max-width: 737px;
  height: 210px;
  ${({ theme, isApproved }) =>
    theme.isDark &&
    css`
      border: 1px solid ${isApproved ? '#27B481' : '#f05a90'};
    `};
  border-radius: 9px;
  h6 {
    font-size: 16px;
    line-height: 20px;
  }
  span {
    font-family: 'Space Grotesk';
    font-size: 14px;
    line-height: 20px;
    opacity: 0.6;
    margin-top: 16px;
    max-width: 556px;
  }
  span.link {
    color: #3d68ff;
    display: flex;
    img {
      margin-left: 8px;
      margin-bottom: -1px;
    }
  }
  .fail-reasons {
    margin: 16px 0;
  }
  li {
    text-indent: -22px;
  }
  @media screen and (max-width: 1000px) {
  }
`

export const Note = styled.span`
  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
`
